import { ContainerSpaceType } from '@portfolio/models'
import { lin } from './lin'

export const getContainerSpace = (containerSpaceType: ContainerSpaceType) => {
  switch (containerSpaceType) {
    case 'none':
      return {
        paddingLeft: 0,
        paddingRight: 0,
      }

    case 'small':
      return lin({
        paddingRight: 'S',
        paddingLeft: 'S',
      })

    case 'medium':
      return lin({
        paddingRight: 'M',
        paddingLeft: 'M',
      })

    case 'large':
      return lin({
        paddingRight: 'L',
        paddingLeft: 'L',
      })

    default:
      return {}
  }
}
